import { castResponseByEndpointType } from "./common";
import { getResultApiUrl } from "../../constants/ApiUrl";
import { OacJsonResponse } from "../../types/demo";
import { endpointStore } from "../../utils/mobx/EndpointStore";
import { envVarStore } from "../../utils/mobx/EnvVarStore";

export const fetchResult = async (
  requestId: string,
): Promise<OacJsonResponse> => {
  const { endpointType } = endpointStore;
  await envVarStore.fetchEnvVars();
  const { backendUrl } = envVarStore;
  const apiUrl = getResultApiUrl(backendUrl, requestId);

  try {
    const response = await fetch(apiUrl);
    const result = await response.json();

    return castResponseByEndpointType(result, endpointType);
  } catch (err) {
    console.error("Failed to fetch result:", err);
    throw err;
  }
};
